<template>
  <div class="dialogWrap">
    <div>
      <vue-qr v-if="url" class="qrStyle" :text="url" style="display: block;width:300px;" />
      <p v-else class="noDataStyle">加载中</p>
      <div class="dialog-footer">
        {{ content }}
      </div>
    </div>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
export default {
  name: 'QrDialog',
  components: {
    VueQr
  },
  props: ['title', 'url', 'content'],
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.dialogWrap {
  img {
    margin: 0 auto;
  }
  .dialog-footer {
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #000;
    padding: 30px 0 10px 0;
    padding-top: 0;
  }
  .noDataStyle{
    text-align: center;
    width: 100%;
    height: 200px;
    line-height: 200px;
    font-size: 24px;
    color: #333;
  }
}
</style>
